export enum OrientationComponentsEnum {
  HORIZONTAL = 'HORIZONTAL',
  VERTICAL = 'VERTICAL',
}
